module.exports = __webpack_public_path__ + "img/c.1200_650.ac8e8578.png";